import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { AnalyticsController } from '../../layout/Analytics';
import './Partners.scss';

export interface PartnersInputs {
    title: string;
    partners: {
        logo: any;
        alt: string;
        title: string;
        id: string;
        uri: string;
    }[];
}

export const Partners = ({ inputs }: { inputs: PartnersInputs }) => {
    return (
        <section className="paragraph__partners">
            <div className="kite-container">
                <h2 className="typestack-title-3">{inputs.title}</h2>
                <KiteGrid>
                    {inputs.partners.map((partner) => {
                        const gImage = getImage(partner.logo.localFile);
                        const title = partner.alt ? partner.alt : partner.title;

                        return (
                            <KiteGridCell
                                className="partner"
                                col={2}
                                sm={2}
                                md={4}
                                key={partner.id}
                            >
                                <h3 className="typestack-title-6">{title}</h3>
                                <GatsbyImage
                                    image={gImage}
                                    alt={`${title} logo`}
                                ></GatsbyImage>
                                <a
                                    href={partner.uri}
                                    target="_blank"
                                    onClick={() => {
                                        AnalyticsController.track({
                                            event: `component click`,
                                            componentLink: `${inputs.title}: ${title}`,
                                        });
                                    }}
                                >
                                    Visit the website of {title}
                                </a>
                            </KiteGridCell>
                        );
                    })}
                </KiteGrid>
            </div>
        </section>
    );
};
